import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, TextField, Button, Autocomplete } from '@mui/material';
import { AiOutlineLeft, AiOutlinePlusCircle } from "react-icons/ai";
import { makeStyles } from '@mui/styles';
import { useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import * as patientActions from '../../core/Store/Actions/PatientActions';
import { medicalConditions } from './medicationList';
import useStyles from './mainStyles';
import ButtonComponent from '../../components/loaderNew';
import { BiPlusCircle } from 'react-icons/bi';

const MedicalCondition = () => {
    const classes = useStyles();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const loading = useSelector(state => state.patientReducer.loading);

    const medicationStore = useSelector(
        state => state.patientReducer.medicationStore,
    );
    const allergiesStore = useSelector(
        state => state.patientReducer.allergiesStore,
    );

    const [selectedMedConditions, setSelectedMedConditions] = useState([]);
    const [extraConditions, setExtraConditions] = useState([]);
    const [medicationsList, setMedicationList] = useState(medicalConditions);
    const addInputMedicalConditionField = (e) => {
        e.preventDefault();
        setExtraConditions([
            ...extraConditions,
            { value: '' },
        ]);
    }
    const removeInputMedicalConditionFields = (index) => {
        let array =
            Object.values(extraConditions);
        array.splice(index, 1);
        setExtraConditions(array);
    }
    const userData = useSelector(state => state.registerReducer.userVerifyData);
    const fhir_patient_id = userData.user?.person?.fhir_patient_id || '';
    const [ChooseMedicalConditions, setChooseMedicalConditions] = useState([]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    const onNextSubmit = (e) => {
        e.preventDefault();
        if (selectedMedConditions && selectedMedConditions.length > 0) {
            let result = extraConditions.map(a => a.value);
            dispatch(patientActions.storeMedicalCondition([...selectedMedConditions,...result]));
        } else {
            dispatch(patientActions.storeMedicalCondition([]));
        }
        navigate('/room/symptoms');
        //onSaveSconsentsMedicalConditionsInfo();
    }
    return (
        <div style={{ padding: '10%', marginBottom: '10%' }}>
            <div style={{
                width: "100%",
                backgroundColor: "white",
                //height: "100%",
                display: "flex",
                flexDirection: "column",
            }}>
                <Typography className='topTitle'>Medical Conditions
                            <a href="" className="backArrow" onClick={(e) => { e.preventDefault(); navigate('/room/medicalHistory'); }}>
                        <AiOutlineLeft />Back</a>
                </Typography>
                <p className="Medicalconditionsinfo">
                    Has the patient ever been diagnosed with any of the following conditions?
                </p>
            </div>
            <div style={{ marginTop: 20 }}>
                <Grid item >
                    {medicationsList.map((item, index) => (
                        <Grid>
                            {/* {console.log("medical data", item, index)} */}
                            <div className="PatientMedicalInfoText">
                                <Autocomplete
                                    multiple
                                    id="tags-standard"
                                    //freeSolo
                                    className="MedicalInfoSelect"
                                    //onChange={handleMedicalConditionsChange}
                                    onChange={(e, value, situation, option) => {
                                        if (
                                            selectedMedConditions.includes(option && option.option.title)
                                        ) {
                                            let array = Object.values(
                                                selectedMedConditions,
                                            );
                                            var index = array.indexOf(option && option.option.title);
                                            if (index > -1) {
                                                array.splice(index, 1);
                                            }
                                            setSelectedMedConditions(array);
                                        } else {
                                            //setSelection(true);
                                            setSelectedMedConditions([
                                                ...selectedMedConditions,
                                                option && option.option.title,
                                            ]);
                                        }
                                    }}
                                    options={item.values}
                                    getOptionLabel={(option) => option.title}
                                    // defaultValue={[MedicationsList[2]]}
                                    renderInput={(params) => (
                                        <TextField
                                            id={item.title}
                                            {...params}
                                            variant="filled"
                                            label={item.title}
                                        />
                                    )}
                                />
                            </div>
                        </Grid>
                    ))}
                    {/* Add Multiple Add Medical Condition Start Here       */}
                    <div className="row">
                        <div className="col-sm-8">
                            {extraConditions ?
                                extraConditions.map((item, index) => {
                                    return (
                                        <div className="row my-3" key={index}>{(extraConditions.length >= 1) ?
                                            <TextField
                                                value={item.title}
                                                margin="normal"
                                                fullWidth
                                                variant="standard"
                                                id="medicalconditionaddmore"
                                                label="Enter medical condition"
                                                name="medicalconditionaddmore"
                                                // onChange={(e) => { console.log("e", e); }}
                                                onInput={(text) => {
                                                    //console.log("Text", text.target.value)
                                                    let array =
                                                        Object.values(extraConditions);
                                                    array[index].value = text.target.value;
                                                    setExtraConditions(array);
                                                }}
                                            />
                                            : ''}
                                            {(extraConditions.length >= 1) ?
                                                <button className="MedicalConditonRemove" onClick={(e) => {e.preventDefault(); removeInputMedicalConditionFields(index)}}>x</button>
                                                : ''
                                            }
                                        </div>)
                                }) : null
                            }
                            <div className="selectedPatientChild" onClick={addInputMedicalConditionField}>
                                <BiPlusCircle className={classes.iconchild} />
                                <span>Add Medical Condition</span>
                            </div>
                        </div>
                    </div>
                    {/* Add Multiple Add Medical Condition End Here       */}


                </Grid>
            </div>
            <div className={classes.PatientNextButton}>
                <ButtonComponent loading={loading}
                    onClick={(e) => { onNextSubmit(e) }} title='Next' />
                {/* <Button
                    size="large"
                    variant="contained"
                    color='primary'
                    fullWidth
                    style={{ width: '100%', padding: '3%', backgroundColor: '#024C9C', fontSize: 18, fontFamily: 'Manrope', marginTop: '20%', alignSelf: 'center' }}
                    disabled={loading}
                    onClick={(e) => { onNextSubmit(e) }}
                >
                    Next
                </Button> */}
            </div>
        </div>
    )
}

export default MedicalCondition
